export default __webpack_public_path__ + "static/media/checkedBoxIcon.a1079ae1.svg";